// Brand tokens and design system constants
export const colors = {
  valcoBlue: '#0F2A44',
  slateBlue: '#457B9D', 
  mistGrey: '#F1FAEE',
  accentOrange: '#FF8C42',
  // LOCKED RULE: Header and footer must always use this navy background
  headerFooterBg: '#0F2A44',
  textOnDark: '#FFFFFF',
  textOnDarkMuted: '#F1FAEE',
} as const;

export const spacing = {
  section: 'py-16 lg:py-24',
  container: 'max-w-7xl mx-auto px-4 sm:px-6 lg:px-8',
  card: 'p-6 lg:p-8',
} as const;

export const typography = {
  h1: 'text-4xl lg:text-6xl font-bold tracking-tight',
  h2: 'text-3xl lg:text-4xl font-bold tracking-tight', 
  h3: 'text-2xl lg:text-3xl font-semibold',
  body: 'text-lg leading-relaxed',
  small: 'text-sm',
} as const;

export const buttons = {
  primary: 'bg-[#FF8C42] hover:bg-[#E17A36] text-white font-semibold px-6 py-3 rounded-lg shadow-md transition-colors',
  secondary: 'bg-[#1D3557] hover:bg-[#16293F] text-white font-semibold px-6 py-3 rounded-lg shadow-md transition-colors',
} as const;

// LOCKED RULE: Header and footer styling tokens
export const lockedComponents = {
  header: `bg-[${colors.headerFooterBg}] text-[${colors.textOnDark}]`,
  footer: `bg-[${colors.headerFooterBg}] text-[${colors.textOnDark}]`,
  navLink: `text-[${colors.textOnDark}] hover:text-[${colors.textOnDarkMuted}]`,
} as const;